import { render, staticRenderFns } from "./ZGRanking.vue?vue&type=template&id=312e35c8&scoped=true"
import script from "./ZGRanking.vue?vue&type=script&lang=js"
export * from "./ZGRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312e35c8",
  null
  
)

export default component.exports